var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('DropDownGroup',{attrs:{"dropDowns":_vm.dropDowns,"onChange":function (value, index) { return _vm.onChange(value, index); }}})}
var staticRenderFns = []

export { render, staticRenderFns }